// extracted by mini-css-extract-plugin
export default {"allcourses":"courseFilter_allcourses__XDMu2","coursetextbox":"courseFilter_coursetextbox__hiCRF","courseslider":"courseFilter_courseslider__D6xa9"};